import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import HighlightTile from './HighlightTile';

const TiledHighlightsViewContainer = styled('div')({
    paddingTop: 16,
    paddingBottom: 16
});

const TiledHighlightsView = ({ highlights, onSelectHighlight }) => {
    const renderHighlightTiles = () => {
        return highlights.map(highlight => (
            <Grid
                key={`highlight-tile-${highlight.id}`}
                size={{
                    xl: 3,
                    lg: 4,
                    md: 4,
                    sm: 6,
                    xs: 12
                }}>
                <HighlightTile
                    highlight={highlight}
                    onClick={() => onSelectHighlight(highlight)}
                />
            </Grid>
        ));
    };

    return (
        <TiledHighlightsViewContainer>
            <Grid container spacing={2}>
                { renderHighlightTiles() }
            </Grid>
        </TiledHighlightsViewContainer>
    );
};

TiledHighlightsView.propTypes = {
    highlights: PropTypes.array.isRequired,
    onSelectHighlight: PropTypes.func
};

export default TiledHighlightsView;
